import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

export const AI_STUDIO_HELP_URL = 'https://zakeke.zendesk.com/hc/en-us/articles/25239933114908-AI-Agents-Studio#h_01KHX76W68DSECT7NQA6M6EJTC';

export const AI_STUDIO_AGENT_HELP_URLS: Record<string, string> = {
    'text-to-3d': 'https://zakeke.zendesk.com/hc/en-us/articles/25239933114908-AI-Agents-Studio#h_01KPT2J4P6BXZMKGVYK3SX0ZX4',
    'image-to-3d': 'https://zakeke.zendesk.com/hc/en-us/articles/25239933114908-AI-Agents-Studio#h_01KPT30N6YTZK9TEJGAMNSR41C',
    'multi-views-to-3d': 'https://zakeke.zendesk.com/hc/en-us/articles/25239933114908-AI-Agents-Studio#h_01KPT30N6Z4M7V95GXDTKTF98H'
};

const HelpAnchor = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    color: #a855f7;
    text-decoration: none;
    cursor: pointer;
    transition:
        color 0.15s ease,
        transform 0.15s ease;

    &:hover {
        color: #7c3aed;
        transform: scale(1.06);
    }

    svg {
        width: 16px;
        height: 16px;
        stroke: currentColor;
        stroke-width: 1.8;
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
`;

const HelpIconSvg: FC = () => (
    <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='12' cy='12' r='10' />
        <path d='M9.5 9a2.5 2.5 0 0 1 5 0c0 1.67-2.5 2.5-2.5 4' />
        <line x1='12' y1='17' x2='12.01' y2='17' />
    </svg>
);

export const AiStudioHelpLink: FC<{ agentId?: string }> = ({ agentId }) => {
    const href = (agentId && AI_STUDIO_AGENT_HELP_URLS[agentId]) || AI_STUDIO_HELP_URL;
    return (
        <HelpAnchor href={href} target='_blank' rel='noopener noreferrer' title={T._('Help & Guide', 'Admin')} aria-label={T._('Help & Guide', 'Admin')}>
            <HelpIconSvg />
        </HelpAnchor>
    );
};

/** Right-aligned wrapper row for the help link when it needs its own line at the bottom of a card */
export const AiStudioHelpRow = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export default AiStudioHelpLink;
